import axios from "axios";
import { baseUrl } from "../../shared/baseUrl";
import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAIL, LOGIN_RESET } from "../constants/userConstants";

export const userLoginAction = (username, password) => async (dispatch) => {
	try {
		dispatch({
			type: LOGIN_REQUEST
		})
		const config = {
			headers: {
				'Content-Type': 'application/json'
			}
		}
		const { data } = await axios.post(
			baseUrl + '/api/v1/auth/login', { username, password }, config
		)

		dispatch({
			type: LOGIN_SUCCESS,
			payload: data
		})

		localStorage.setItem("userInfo", JSON.stringify(data))
	}

	catch (error) {
		dispatch({
			type: LOGIN_FAIL,
			payload: error.response && error.response.data.message
				? error.response.data.message
				: error.message
		})
	}
}

export const userLogoutAction = () => (dispatch) => {
	localStorage.removeItem("userInfo")
	localStorage.removeItem("profile")
	dispatch({
		type: LOGIN_RESET
	})
}